import type { InsightsInsightsPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Export, ExportRow, GenerateExport } from './export'

type EmployeesAgeHeadcount =
  InsightsInsightsPageQuery['employees']['ageHeadcountsConnection']['nodes'][number]

const RANGES = [[18, 25], [26, 35], [36, 45], [46, 55], [56, 65], [66]]
const isBetween = (range: number[], data: EmployeesAgeHeadcount) => {
  const { age } = data
  const [min, max] = range

  if (range.length > 1) {
    return age >= min! && age <= max!
  }

  return age >= min!
}

const groupByAgeRange = (employeesAverageAge: EmployeesAgeHeadcount[]) => {
  const results: { range: string; count: number }[] = []

  RANGES.forEach((range) => {
    const filteredRange = employeesAverageAge.filter((employeesAge) =>
      isBetween(range, employeesAge)
    )
    const count = filteredRange
      .map(({ count }) => count)
      .reduce((prev, current) => prev + current, 0)

    const key = range.join(' - ')

    results.push({ range: key, count })
  })

  return results
}

export default class AgeRangeDistribution implements GenerateExport {
  private employeesAverageAge: EmployeesAgeHeadcount[]

  constructor(employeesAverageAge: EmployeesAgeHeadcount[]) {
    this.employeesAverageAge = employeesAverageAge
  }

  isEmpty() {
    return !this.employeesAverageAge.length
  }

  export(): Export {
    const data: ExportRow[][] = [
      [
        i18n.t('insights.widgets.age_range_distribution.bar_tooltip'),
        i18n.t('insights.widgets.shared.headcount'),
      ],
    ]

    this.generate().forEach((record) => {
      data.push([record.range, record.count])
    })

    return { title: i18n.t('insights.widgets.age_range_distribution.title'), data }
  }

  generate() {
    return groupByAgeRange(this.employeesAverageAge)
  }
}
